import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import defaultAxios, { AxiosError } from "axios";
import { useCallback } from "react";
import Swal from "sweetalert2";
import { useHapusMultipleStokModal } from "../../context/hapusMultipleStokModalContext";
import axios from "../../services/axios";

interface IModalDeleteMultipleStokProps {
    refetch: () => void;
    handleCollapseClose: () => void;
}

const ModalDeleteMultipleStok = ({ refetch, handleCollapseClose }: IModalDeleteMultipleStokProps) => {
    const {
        isOpenModalHapusMultipleStok,
        closeModalHapusMultipleStok,
        selectedProducts,
        clearSelectedProducts
    } = useHapusMultipleStokModal();
  
    const handleDelete = async () => {
        try {
            const response = await axios.post('/api/item-delete', {
                itemId: selectedProducts.map(product => product.id),
            });
            if (response.status === 200) {
                clearSelectedProducts();
                Swal.fire({
                    title: "Item berhasil dihapus!",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
                refetch();
                closeModalHapusMultipleStok();
                handleCollapseClose();
            } else {
                console.error('Failed to delete products');
            }
        } catch (error) {
            handleErrorResponse(error);
        }
    };
  
    const handleErrorResponse = useCallback(
        (error) => {
            if (defaultAxios.isAxiosError(error)) {
                const serverError = error as AxiosError<any>;
                if (serverError && serverError.response) {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `${serverError.response.data.message}`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalHapusMultipleStok();
                } else {
                    Swal.fire({
                        title: "Terjadi Kesalahan!",
                        text: `Telah Terjadi Kesalahan`,
                        icon: "error",
                        confirmButtonColor: "#45A779",
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalHapusMultipleStok();
                }
            }
        },
        [closeModalHapusMultipleStok],
    );

    return (
        <Dialog
            maxWidth="xs"
            fullWidth={true}
            open={isOpenModalHapusMultipleStok}
            onClose={closeModalHapusMultipleStok}
            PaperProps={{
                sx: {
                    borderRadius: 1,
                },
            }}
        >
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton onClick={closeModalHapusMultipleStok}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight="bold">
                        Hapus Barang
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Apakah Anda yakin ingin menghapus barang yang dipilih secara permanen?
                    {selectedProducts.length > 0 && (
                        <ul>
                            {selectedProducts.map((product) => (
                                <li key={product.id}>{product.nama}</li>
                            ))}
                        </ul>
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: 2 }}>
                <Button variant="outlined" onClick={handleDelete} color="error">
                    Hapus
                </Button>
                <Button
                    variant="contained"
                    onClick={closeModalHapusMultipleStok}
                    color="error"
                >
                    Tidak
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalDeleteMultipleStok;
